<div id="drawer" class="drawer" #drawer>
  <div class="drawer-header">
    <div class="ion-text-center handle-area" (click)="drawerVisibility()">
      <span class="grabber"></span>
    </div>

    <div class="header-row">
      <div class="header-brand">
        <img class="brand-logo" [src]="staffyLogo" [ngClass]="{'logo-spacing': (staffyLogo?.includes('hospitality'))}">
        <div class="header-titles">
          <h2 class="header-title">Notifications</h2>
          <span class="header-sub" *ngIf="unreadCount > 0">{{ unreadCount }} new update{{ unreadCount > 1 ? 's' : '' }}</span>
          <span class="header-sub" *ngIf="!unreadCount">You're all caught up</span>
        </div>
      </div>
      <button class="close-btn" (click)="drawerVisibility()">
        <i class="fa fa-chevron-down"></i>
      </button>
    </div>
  </div>

  <div class="wrapper" #wrapper>
    <!-- Message of the day -->
    <div *ngIf="userData?.profile_approved == true && userData?.type == 'staffer'">
      <div class="motd-card" *ngIf="message" (click)="showMOTD($event)">
        <div class="motd-glow motd-glow--one"></div>
        <div class="motd-glow motd-glow--two"></div>
        <div class="motd-shine"></div>
        <img class="motd-watermark" src="assets/images/staffy-logo-icon.png" alt="" aria-hidden="true">

        <div class="motd-top">
          <div class="motd-icon">
            <img src="assets/images/staffy-logo-icon.png" alt="Staffy">
          </div>
          <div class="motd-heading">
            <span class="motd-label">Message of the day</span>
            <span class="motd-date">
              <i class="fa fa-calendar-o"></i>
              {{ currentDate }}
            </span>
          </div>
          <span class="motd-brand">STAFFY</span>
        </div>

        <p class="motd-text">{{ message }}</p>

        <div class="motd-footer">
          <span class="motd-cta">
            Read full message
            <i class="fa fa-arrow-right"></i>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="!notifications && isLoadingComplete" class="no-shifts">
      <app-no-context-found [noShiftsData]="noShifts"></app-no-context-found>
    </div>

    <div *ngIf="notifications">
      <div class="notif-group" *ngFor="let notification of notifications | keyvalue: returnZero">
        <div class="group-header" *ngIf="notification.key">
          <span class="group-line"></span>
          <span class="group-label">{{ notification.key }}</span>
          <span class="group-line"></span>
        </div>

        <div *ngFor="let notify of notification.value">
          <shared-notification-card *ngIf="!notify.groupJobId" style="width: 100%" [userData]="userData"
            [hour24PayAvailableBadge]="hour24PayAvailableBadge" [settings]="settings"
            (acceptNonRecurringBroadcastRequest)="acceptNonRecurringBroadcastRequest($event)"
            (rejectStafferBroadcastRequest)="rejectStafferBroadcastRequest($event)"
            (seeAvailableJobs)="seeAvailableJobs()" (updateUser)="updateUser($event)"
            (confirmNonRecurringShift)="confirmNonRecurringShift($event, notify)"
            (unApplyFromNonRecurringShift)="unApplyFromNonRecurringShift($event)"
            (rejectNonRecurringJob)="rejectNonRecurringJob($event)"
            (stopTimerOnNonRecurringJob)="stopTimerOnJob($event)" (submitRating)="submitRating($event)"
            (stafferStillWorkingOnNonRecurringJob)="stafferStillWorkingOnJob($event)"
            (hireStafferForTheNonRecurringJob)="hireStafferForTheNonRecurringJob($event)"
            (acceptNonRecurringHireRequest)="acceptNonRecurringHireRequest($event)" (click)="cardClicked(notify)"
            [notification]="notify"
            (hideNotificationDrawer)="drawerVisibility('/talent-dashboard/shift-details')">
          </shared-notification-card>
          <shared-notification-card-recurring *ngIf="notify.groupJobId" style="width: 100%" [userData]="userData"
            [hour24PayAvailableBadge]="hour24PayAvailableBadge" [settings]="settings"
            (acceptRecurringBroadcastRequest)="acceptRecurringBroadcastRequest($event)"
            (rejectStafferRecurringBroadcastRequest)="rejectStafferRecurringBroadcastRequest($event)"
            (confirmRecurringShift)="confirmRecurringShift($event, notify)" (updateUser)="updateUser($event)"
            (acceptRecurringHireRequest)="acceptRecurringHireRequest($event)"
            (rejectRecurringHireRequest)="rejectRecurringHireRequest($event)"
            (stafferStillWorkingOnRecurringJob)="stafferStillWorkingOnJob($event)"
            (stopTimerOnRecurringJob)="stopTimerOnJob($event)" (submitRating)="submitRating($event)"
            (hireStafferForTheRecurringJob)="hireStafferForTheRecurringJob($event)"
            (unApplyFromRecurringShift)="unApplyFromRecurringShift($event)" (click)="cardClicked(notify)"
            [notification]="notify"
            (hideNotificationDrawer)="drawerVisibility('/talent-dashboard/shift-details')">
          </shared-notification-card-recurring>
        </div>
      </div>
      <div class="clear-wrap" *ngIf="!notificationId">
        <button class="clear-btn" (click)='clear()'>
          <i class="fa fa-trash-o"></i>
          {{ 'NOTIFICATIONS.Clear Previous Notifications' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
